import React from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn, EAA_Date, EAA_Upload } from '~/components/EditAndAddItem';
import * as getTime from '~/skills/getTime';

const emptyBody = {
  PPA_CPPA_date: '',
  PPA_CPPA_price: '',
  PPA_CPP_object: '',
  sign_upload_files: [],
};

const App = props => {
  const { titleWidth, disabled, checkChange, changeData, data, checkSubChange } = props;
  const ary = data.sub1 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub1', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  const renderAry = [];
  for (let i = 0; i < ary.length; i++) {
    const isFirst = i === 0;
    renderAry.push(
      <EAA_Row key={`Page_Finance_sub1_1_${i}`}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text='' />
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)' }}>簽署對象</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 15, marginLeft: 50 }}>價格</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 15 }}>簽署日期</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 168 }}>簽署合約上傳</div>
          </EAA_ItemContainer>
        </EAA_Item>
      </EAA_Row>,
    );
    renderAry.push(
      <EAA_Row key={`Page_Finance_sub1_2_${i}`} style={{ marginTop: 0 }}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text={isFirst ? 'PPA/CPPA簽署' : ''} subtitleColor='black' bol={isFirst} haveChange={checkSubChange(1, [emptyBody])} />
            <EAA_Input hint='簽署對象' displayBorder disabled={disabled} value={ary[i].PPA_CPP_object} onChange={data => { ary[i].PPA_CPP_object = data; saveSub(ary); }} marginRight={8} />
            <div style={{ fontSize: 16, fontWeight: 400, marginRight: 4 }}>新台幣</div>
            <EAA_Input hint='價格' displayBorder type='number' disabled={disabled} unit='元' value={ary[i].PPA_CPPA_price} onChange={data => { ary[i].PPA_CPPA_price = data; saveSub(ary); }} marginRight={8} />
            <EAA_Date hint='簽署日期' displayBorder disabled={disabled} value={getTime.returnDate(ary[i].PPA_CPPA_date)} onChange={data => { ary[i].PPA_CPPA_date = getTime.getType3Time(data); saveSub(ary); }} marginRight={8} />
            <EAA_Upload marginRight={8} displayBorder disabled={disabled} hint='簽署合約上傳' value={ary[i].sign_upload_files} onChange={data => { ary[i].sign_upload_files = data; saveSub(ary); }} />
            <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
          </EAA_ItemContainer>
          {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
        </EAA_Item>
      </EAA_Row>,
    );
  }
  return renderAry;
};
export default App;
